export class RentalFileSummary {
  constructor(
    rental_file_technical_id,
    rental_file_boomerang_id,
    rental_file_status,
    product_manufacturer_name_ref,
    store_name,
    client_name,
    client_company_name,
    send_date,
    requestor_full_name,
    repair_file_boomerang_id
  ) {
    this.rental_file_technical_id = rental_file_technical_id
    this.rental_file_boomerang_id = rental_file_boomerang_id
    this.rental_file_status = rental_file_status
    this.product_manufacturer_name_ref = product_manufacturer_name_ref
    this.store_name = store_name
    this.client_name = client_name
    this.client_company_name = client_company_name
    this.send_date = send_date
    this.requestor_full_name = requestor_full_name
    this.repair_file_boomerang_id = repair_file_boomerang_id
  }
}
